export const SET_LANG = 'SET_LANG';//设置语言
export const SET_LOGIN_USER = 'SET_LOGIN_USER';//设置登录用户
export const SET_STATE_CODE_LIST = 'SET_STATE_CODE_LIST';//设置状态代码集合